import React, { ReactNode } from 'react';
import { usePageTransition, TransitionType } from '../../Hooks/usePageTransition';

interface PageWrapperProps {
  children: ReactNode;
  transitionType?: TransitionType;
  delay?: number;
  className?: string;
  style?: React.CSSProperties;
}

const PageWrapper: React.FC<PageWrapperProps> = ({
  children,
  transitionType = 'fade',
  delay = 50,
  className = '',
  style = {}
}) => {
  const { getTransitionClasses } = usePageTransition({
    delay,
    transitionType
  });

  return (
    <div 
      className={`${getTransitionClasses()} ${className}`}
      style={style}
    >
      {children}
    </div>
  );
};

export default PageWrapper; 